export function SET_PENDING_FETCHES(state, pendingFetches) {
  state.pendingFetches = pendingFetches;
}

export function SET_HAS_FETCHED(state, hasFetched) {
  state.hasFetched = hasFetched;
}
